import React from "react";
import PropTypes from "prop-types";
import MUIDataTable from "mui-datatables";
import { Box, CircularProgress } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    cardTitle: {
      fontSize: 14,
      fontWeight: 700,
      color: "#1f2937",
    },
    loadingWrap: {
      minHeight: 240,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    tableWrap: {
      marginTop: theme.spacing(1),
    },
  })
);

const PlotEventTable = ({ rows, loading }) => {
  const classes = useStyles();
  const csvHeaders = [
    "plot_id",
    "user_id",
    "category",
    "latitude",
    "longitude",
    "captured_at",
    "area_code",
  ];

  const escapeCsvValue = (value) => {
    if (value === null || value === undefined) {
      return "";
    }

    return String(value).replace(/"/g, '""');
  };

  const columns = [
    {
      name: "プロットID",
      options: {
        filter: false,
      },
    },
    {
      name: "ユーザーID",
      options: {
        filter: false,
      },
    },
    {
      name: "カテゴリ",
      options: {
        filter: true,
      },
    },
    {
      name: "緯度",
      options: {
        filter: false,
      },
    },
    {
      name: "経度",
      options: {
        filter: false,
      },
    },
    {
      name: "撮影時間",
      options: {
        filter: false,
      },
    },
    {
      name: "市区町村エリアID",
      options: {
        filter: true,
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "checkbox",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    viewColumns: false,
    downloadOptions: {
      filename: "防災CS_プロット一覧.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    onDownload: (_buildHead, _buildBody, _columnsForDownload, dataForDownload) => {
      const rowsForDownload = dataForDownload.map((row) => row.data);
      const headerRow = csvHeaders.join(",");
      const bodyRows = rowsForDownload.map((row) =>
        row
          .map((cell) => `"${escapeCsvValue(cell)}"`)
          .join(",")
      );

      return "\uFEFF" + [headerRow, ...bodyRows].join("\n");
    },
    rowsPerPage: 100,
    rowsPerPageOptions: [100, 200, 500],
    responsive: "standard",
    textLabels: {
      body: {
        noMatch: loading ? "LOADING..." : "データがありません。",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
  };

  return (
    <div className={classes.tableWrap}>
      {loading && rows.length === 0 ? (
        <Box className={classes.loadingWrap}>
          <CircularProgress size={32} />
        </Box>
      ) : (
        <MUIDataTable
          title={<span className={classes.cardTitle}>プロット一覧</span>}
          data={rows}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
};

PlotEventTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.array).isRequired,
  loading: PropTypes.bool,
};

PlotEventTable.defaultProps = {
  loading: false,
};

export default PlotEventTable;
